import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function (props) {
	return (
		<span className="mdl-navigation__link mdl-typography--text-uppercase" onClick={props.onClick}>
			{props.children}
		</span>
	);
});
